

import React from 'react';
import '../styles/loading-spinner.css'; // import the styles

export const LoadingComponent =()=>{
     
    return (
      <div className="spinner-overlay">
        <div className="loader"></div>
        </div> 
    );

}